import { Injectable, inject } from "@angular/core";
import { WorkBook, utils, read } from "xlsx";

import { CsvService } from "./csv.service";
import { ExcelData } from "@shared/classes/excel-data";
import { CsvImportColumnName, ExcelSheetName } from "@shared/constants";
import { Utilities } from "@shared/utils/utilities";
import { KPINameNameIdMapping } from "@shared/enums";

@Injectable({
  providedIn: 'root'
})
export class ExcelImportService {
  csvService = inject(CsvService);

  constructor() { }

  OnFileSlected(file: File, sheetNameList: string[], onFileProcess: (fileData: any[]) => void, onNoDataProcess: () => void) {
    this.ReadExcelData(file, sheetNameList, (sheetList: ExcelData[]) => {
      var csvDataList = sheetList.flatMap(item => item.sheetCsvData);
      if (csvDataList.length === 0) {
        onNoDataProcess();
      }
      else {
        onFileProcess(csvDataList);
      }
    });
  }

  ReadExcelData(file: File, sheetNameList: string[], dataProcessAfterRead: (sheetList: ExcelData[]) => void) {
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target!.result;
      const wb = read(bstr, { type: 'binary' });
      var fileData = this.GetImportExcelFileData(wb);
      var sheetList = this.GetSheetDataBySheetNames(fileData, sheetNameList);
      sheetList.forEach(item => {
        var csvData = this.csvService.GenerateDataArrayFromCSVText(item.sheetData);
        this.AttachKpiIdBySheetName(item.sheetName, csvData);
        this.AttachSheetName(item.sheetName, csvData);
        item.sheetCsvData = csvData;
      });

      dataProcessAfterRead(sheetList);
    }

    reader.readAsArrayBuffer(file);
  }

  private GetImportExcelFileData(wb: WorkBook) {
    return wb.SheetNames.map((sheetName: string) => {
      const ws = wb.Sheets[sheetName];
      const data = utils.sheet_to_csv(ws, { forceQuotes: true });
      return {
        sheetName: sheetName,
        sheetData: data
      } as ExcelData;
    });
  }

  private GetSheetDataBySheetNames(excelData: ExcelData[], sheetNameList: string[]) {
    if (!excelData || excelData.length === 0) {
      return [];
    }

    if (excelData.length === 1 || sheetNameList.length === 0) {
      return [excelData[0]];
    }

    return excelData.filter(data => sheetNameList.includes(data.sheetName.toLocaleLowerCase()));
  }

  private AttachSheetName(sheetName: string, dataList: any[]) {
    if (!dataList) {
      return;
    }

    dataList.forEach(dataItem => dataItem[CsvImportColumnName.SHEET_NAME] = sheetName);
  }

  private AttachKpiIdBySheetName(sheetName: string, dataList: any[]) {
    switch (sheetName.toLocaleLowerCase()) {
      case ExcelSheetName.DRIVER_OBSERVATION:
        this.AttachKpiId(dataList, KPINameNameIdMapping.DRIVER_OBSERVATION);
        break;

      case ExcelSheetName.EVCR_COMPLIANCE:
        this.AttachKpiId(dataList, KPINameNameIdMapping.EVCR_COMPLIANCE);
        break;

      case ExcelSheetName.APT_COMPLIANCE:
        this.AttachKpiId(dataList, KPINameNameIdMapping.APT_COMPLIANCE);
        break;

      case ExcelSheetName.SAFETY_MEETING_COMPLIANCE:
        this.AttachKpiId(dataList, KPINameNameIdMapping.SAFETY_MEETING_COMPLIANCE);
        break;

      default:
        break
    }
  }

  private AttachKpiId(dataList: any[], kpiId: string) {
    if (!dataList || dataList.length === 0 || Utilities.isEmptyString(kpiId)) {
      return;
    }

    dataList.forEach(dataItem => dataItem[CsvImportColumnName.KPI_ID] = kpiId);
  }
}
